import React, {Component} from "react";
import {observer, inject} from "mobx-react";
import {message} from "antd";

import "../common.css";

@inject("content")
@observer
class PunctuationConverter extends Component {
  // 英文标点转中文标点的映射表
  punctuationMap = {
    ",": "，",
    ".": "。",
    ";": "；",
    ":": "：",
    "!": "！",
    "?": "？",
    "(": "（",
    ")": "）",
    "[": "【",
    "]": "】",
    "{": "「",
    "}": "」",
    "<": "《",
    ">": "》",
  };

  convertPunctuation = () => {
    const {content} = this.props.content;

    if (!content || content.trim() === "") {
      message.warning("内容为空，无法转换！");
      return;
    }

    // 转换标点符号
    let convertedContent = content;

    // 处理双引号的开闭配对
    let quoteOpen = true;
    convertedContent = convertedContent.replace(/"/g, () => {
      const result = quoteOpen ? '"' : '"';
      quoteOpen = !quoteOpen;
      return result;
    });

    // 处理单引号的开闭配对
    let singleQuoteOpen = true;
    convertedContent = convertedContent.replace(/'/g, (match, offset, string) => {
      // 如果单引号在代码块中，不转换
      const beforeText = string.substring(0, offset);
      const codeBlockCount = (beforeText.match(/```/g) || []).length;
      const inlineCodeCount = (beforeText.match(/`/g) || []).length;

      // 在代码块或行内代码中，不转换
      if (codeBlockCount % 2 !== 0 || inlineCodeCount % 2 !== 0) {
        return match;
      }

      const result = singleQuoteOpen ? "'" : "'";
      singleQuoteOpen = !singleQuoteOpen;
      return result;
    });

    // 转换其他标点符号（避免在代码块中转换）
    const lines = convertedContent.split("\n");
    let inCodeBlock = false;

    convertedContent = lines
      .map((line) => {
        // 检查是否进入或退出代码块
        if (line.trim().startsWith("```")) {
          inCodeBlock = !inCodeBlock;
          return line;
        }

        // 如果在代码块中，不转换
        if (inCodeBlock) {
          return line;
        }

        // 处理行内代码
        const parts = line.split("`");
        return parts
          .map((part, index) => {
            // 奇数索引的部分是行内代码，不转换
            if (index % 2 !== 0) {
              return part;
            }

            // 转换非代码部分的标点
            let result = part;
            for (const [en, zh] of Object.entries(this.punctuationMap)) {
              const escapedChar = en.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
              result = result.replace(new RegExp(escapedChar, "g"), zh);
            }
            return result;
          })
          .join("`");
      })
      .join("\n");

    // 更新内容
    this.props.content.setContent(convertedContent);
    message.success("标点符号转换成功！");
  };

  render() {
    return (
      <div id="nice-menu-punctuation-converter" className="nice-menu-item" onClick={this.convertPunctuation}>
        <span>
          <span className="nice-menu-flag" />
          <span className="nice-menu-name">英转中标点</span>
        </span>
      </div>
    );
  }
}

export default PunctuationConverter;
